import React, { type FC, useEffect } from "react";

const Root: FC = () => {
  useEffect(() => {
    const url = new URL(window.location.href);
    const deeplink = url.searchParams.get("deeplink");

    if (deeplink) {
      url.searchParams.delete("deeplink");
      url.pathname = `/travel/accommodation/${deeplink}`;

      window.history.replaceState(null, document.title, url.toString());
    }
  }, []);

  return <></>;
};

export default Root;
